<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0 mb-6" outlined>
      <DiligenceStudentReportFilter @onFilterChanged="refresh" />
    </v-card>
    <v-card class="ma-6" outlined>
      <DiligenceStudentReportTable ref="diligence-data-table" :filters="filters" />
    </v-card>
  </div>
</template>

<script>
import DiligenceDataTable from './components/DiligenceDataTable'
import DiligenceStudentReportFilter from './components/DiligenceStudentReportFilter.vue'
import DiligenceStudentReportTable from './components/DiligenceStudentReportTable.vue'

export default {
  components: {
    DiligenceDataTable,
    DiligenceStudentReportFilter,
    DiligenceStudentReportTable,
  },
  data() {
    return {
      filters: null,
    }
  },
  methods: {
    refresh(query) {
      this.filters = query
      this.$nextTick(() => {
        this.$refs['diligence-data-table'].searchStudentDiligences()
      })
    },
  },
}
</script>
